var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2491 2.93466C11.5419 3.22767 11.5417 3.70254 11.2487 3.99532C10.9557 4.28809 10.4808 4.2879 10.1881 3.99489L8.74983 2.55552L8.74983 11.6276C8.74983 12.0418 8.41404 12.3776 7.99983 12.3776C7.58562 12.3776 7.24983 12.0418 7.24983 11.6276L7.24983 2.55552L5.8116 3.99489C5.51883 4.2879 5.04395 4.28809 4.75094 3.99532C4.45793 3.70254 4.45774 3.22767 4.75052 2.93466L7.46929 0.213718C7.60996 0.0729352 7.80081 -0.00616455 7.99983 -0.00616455C8.19885 -0.00616455 8.3897 0.0729352 8.53037 0.213718L11.2491 2.93466ZM16 9.81425C16 9.40004 15.6643 9.06425 15.25 9.06425C14.8358 9.06425 14.5 9.40004 14.5 9.81425V14.5061L1.49994 14.5061L1.49994 9.81425C1.49994 9.40004 1.16415 9.06425 0.749939 9.06425C0.335726 9.06425 -6.10352e-05 9.40004 -6.10352e-05 9.81425V15.2561C-6.10352e-05 15.6703 0.335726 16.0061 0.749939 16.0061L15.25 16.0061C15.6643 16.0061 16 15.6703 16 15.2561L16 9.81425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhite);
export default __webpack_public_path__ + "static/media/Share-White.7f699089b837ad5bb462f2d58b508608.svg";
export { ForwardRef as ReactComponent };